import React, { useEffect, useState } from 'react';
import api from '~/services/api';
import CreateContent from './CreateContent';
import EditContent from './EditContent';
import { LandPage, Container, Main } from './styles';
import CustomBodyContent from './CustomBodyContent';
import { Colors } from '~/config/Colors';
import { SLEditModal, SLCreateModal } from '~/pages/Sistema/componentes/SistemaList';
import { useSelector } from 'react-redux';

export default function OrdemServico() {
  const [data, setData] = useState([]);
  const [modulos, setModulos] = useState([]);
  const [anos, setAnos] = useState([]);
  const [anoAtivo, setAnoAtivo] = useState(new Date().getFullYear());
  const [clientes, setClientes] = useState([]);
  const [projetos, setProjetos] = useState([]);
  const [clienteFiltro, setClienteFiltro] = useState([]);
  const [projetoFiltro, setProjetoFiltro] = useState([]);
  const [mountedData, setMountedData] = useState();
  const [loadedData, setLoadedData] = useState(false);
  const [osRejeitada, setOsRejeitada] = useState(false);
  const [quantRejeitada, setQuantRejeitada] = useState(0);
  const { perfil } = useSelector(state => state.auth);

  useEffect(() => {
    setLoadedData(false);
  }, [anoAtivo, clienteFiltro]);

  useEffect(() => {
    setLoadedData(false);
  }, [perfil]);

  useEffect(() => {
    let count = 0;

    for (let item of data) {
      for (let mes of item?.meses ?? []) {
        for (let itemList of mes?.list ?? []) {
          if (itemList?.statusAprovacao == 'R') {
            setOsRejeitada(true);

            count += 1;
          }
        }
      }
    }

    setQuantRejeitada(count);
  }, [data]);

  useEffect(() => {
    async function handleRequests() {
      api.get('/signed/geral/acessos/check').then(response => setModulos(response.data));
    }
    handleRequests();

    api
      .get('/signed/empresa/gestorprojeto/ordemservico/projetos', {
        params: { ativo: 1, semData: true },
      })
      .then(response => setProjetos(response.data));

    setAnos([
      { id: new Date().getFullYear() - 2 },
      { id: new Date().getFullYear() - 1 },
      { id: new Date().getFullYear() },
    ]);
  }, []);

  useEffect(() => {
    api
      .get('/signed/empresa/gestorprojeto/ordemservico/projetos', {
        params: { ativo: 1, idCliente: clienteFiltro, semData: true },
      })
      .then(response => setProjetos(response.data));
  }, [clienteFiltro]);

  return (
    <Main>
      <LandPage>
        <div className="content">
          <Container
            className="container-os"
            requests={{
              findAll: () =>
                api.get('/signed/empresa/suporte/ordensservicos', {
                  params: { idCliente: clienteFiltro, idProjeto: projetoFiltro, ano: anoAtivo },
                }),
              findOne: thisData =>
                api.get('/signed/empresa/suporte/ordemservico', {
                  params: { id: thisData.id },
                }),
              deleteOne: thisData =>
                api.delete('/signed/empresa/suporte/ordemservico', {
                  data: { id: thisData.id },
                }),
            }}
            selects={[
              {
                list: clientes,
                value: 'id',
                label: 'nomeFantasia',
                outLabel: 'Todos os Clientes',
                filter: 'meses.list.idCliente',
                onChange: idCliente => {
                  setClienteFiltro(idCliente);
                },
              },
              {
                list: projetos,
                value: 'id',
                label: 'titulo',
                outLabel: 'Todos os Projetos',
                filter: 'meses.list.idProjeto',
                onChange: idProjeto => {
                  setProjetoFiltro(idProjeto);
                },
              },
            ]}
            setter={setData}
            setLoaded={setLoadedData}
            loaded={loadedData}
            informationPage={{
              title: 'Ordem de Serviço',
              subTitle: 'Crie e Gerencie as suas OS',
              icone: 'menu-os',
              menu: true,
            }}
            tabFilter={{
              initial: { statusAprovacao: '*' },
              tabAtivo: 4,
              list: [
                {
                  corDestaque: '#707070',
                  corFundo: Colors?.Color8,
                  title: 'Encerradas',
                  value: { statusAprovacao: 'E' },
                },
                {
                  corDestaque: localStorage.getItem('tema') == 'E' ? '#9A3636' : '#e68282',
                  corFundo: Colors?.Color8,
                  title: 'Rejeitadas',
                  value: { statusAprovacao: 'R' },
                },
                {
                  corDestaque: '#76BD3E',
                  corFundo: Colors?.Color8,
                  title: 'Aguard. Aprovação Tec',
                  value: { statusAprovacao: 'C' },
                },
                {
                  corDestaque: '#dee54d',
                  corFundo: Colors?.Color8,
                  title: 'Aguard. Aprovação Coord',
                  value: { statusAprovacao: 'A' },
                },
                {
                  corDestaque: Colors?.Color4,
                  corFundo: Colors?.Color8,
                  title: 'Todas',
                  value: { statusAprovacao: '*' },
                },
              ],
            }}
          >
            <SLEditModal menu={true} title="Atualizar Ordem de Serviço" setter={setMountedData}>
              {mountedData && <EditContent {...{ mountedData }} />}
            </SLEditModal>

            <SLCreateModal menu={true} title="Adicionar Ordem de Serviço">
              {modulos && <CreateContent {...{ modulos }} />}
            </SLCreateModal>

            <CustomBodyContent
              {...{ quantRejeitada, osRejeitada, data, anos, anoAtivo, setAnoAtivo }}
            />
          </Container>
        </div>
      </LandPage>
    </Main>
  );
}
